import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'

import { forgeApi } from '../..'
import { UnshareArtifactPositionsRequest } from './unshareArtifactPositions.types'

export const unshareArtifactPositions = async ({
  publicId,
  positionIds
}: UnshareArtifactPositionsRequest): Promise<void> => {
  await forgeApi.delete(
    `/api/v1/artifacts/${encodeURIComponent(publicId)}/shares`,
    { data: { position_ids: positionIds } }
  )
}

export const useUnshareArtifactPositionsMutation = (
  options?: ExtendableMutationOptions<void, UnshareArtifactPositionsRequest>
) =>
  useMutation({
    mutationFn: unshareArtifactPositions,
    ...options
  })
